import { useIntlUds } from '../../../../../../../translations/UdsIntlProvider';
import { useCallback } from 'react';
import { dateToIsoDateFormat } from '../../../../../../../utils';
import type { RelativeDateRangeModelInput } from '../types';

export function useRelativeDateRangeTemplateLabel() {
  const { intl, format } = useIntlUds();

  return useCallback(
    (model: Partial<RelativeDateRangeModelInput> | undefined) => {
      if (model === undefined || !model?.type) return '';
      switch (model.type) {
        case 'IS_IN_THE_LAST':
          return format(intl.DataTable.Filters.relativeDateRange.IS_IN_THE_LAST[model.timeUnit ?? 'DAY'], {
            amount: `${model.amount ?? 0}`
          });
        case 'IS_IN_THE_NEXT':
          return format(intl.DataTable.Filters.relativeDateRange.IS_IN_THE_NEXT[model.timeUnit ?? 'DAY'], {
            amount: `${model.amount ?? 0}`
          });
        case 'IS_WITHIN_THIS':
          return format(intl.DataTable.Filters.relativeDateRange.IS_WITHIN_THIS, { timeUnit: model.timeUnit ?? 'DAY' });
        case 'IS_IN_BETWEEN':
          if (model.from && model.to) {
            return format(intl.DataTable.Filters.relativeDateRange.IS_IN_BETWEEN.FROM_TO, {
              from: model.from,
              to: model.to
            });
          }
          if (model.from) {
            return format(intl.DataTable.Filters.relativeDateRange.IS_IN_BETWEEN.FROM, { from: model.from });
          }
          if (model.to) {
            return format(intl.DataTable.Filters.relativeDateRange.IS_IN_BETWEEN.FROM, { to: model.to });
          }
          return '';
        case 'IS_ON':
          return model.from
            ? format(intl.DataTable.Filters.relativeDateRange.IS_ON, { on: dateToIsoDateFormat(new Date(model.from)) })
            : '';
        case 'IS_EMPTY':
          return intl.DataTable.Filters.relativeDateRange.IS_EMPTY;
      }
    },
    [intl, format]
  );
}
